const Form087TC = {
    stepName: {
        importantNotes: "重要事項",
        information: "資料",
        confirmation: "確認",
    },
    title: {
        applicantParticulars: "上載報名表格",
        applicantParticulars2: "提交報名申請",
        schoolInformation: "以下內容由學校／機構填寫",
        note: "注意",
        collectionStatement: "個人資料收集聲明",
    },
    label: {
        nameEn: "英文姓名",
        nameCn: "中文姓名",
        email: "電郵地址 （用作接收與修讀本課程相關的電郵）",
        HKAccount: "香港教育城教師帳戶名稱（用作登入本課程平台）",
        schoolOrOrganisationTel: "學校／機構電話號碼",
        select: "（請選擇）",
        schoolTelNo: "學校電話號碼",
        organisationTelNo: "機構電話號碼",
        schoolOrOrganisationName: "學校／機構名稱：",
        schoolName: "學校名稱",
        organisationName: "機構名稱",
        reason: "推薦原因",
        schoolOrOrganisationChop: "學校／機構蓋印：",
        schoolChop: "學校蓋印",
        organisationChop: "機構蓋印",
        principalOrPersonName: "校長／負責人姓名：",
        principalName: "校長姓名",
        personName: "負責人姓名",
        principalOrPersonSignature: "校長／負責人簽署：",
        principalSignature: "校長簽署",
        personSignature: "負責人簽署",
        date: "日期",
        applicationPeriod: "報名日期：",
        courseDuration: "修讀日期：",
        accountName: "帳戶名稱",
        reasonMessage: "原因",
        noNameCn: "我沒有中文姓名。",
        attachment:
            "申請人須將已填妥的表格（甲、乙兩個部分皆須填妥）作為附檔上載給教育局。",
        courseIdEn: "英文版本（課程編號:{{cdiNumEn}}）",
        courseIdCn: "中文版本（課程編號:{{cdiNumTc}}）",
        chooseVersion: "請選擇課程的語文版本：",
        pdfExplanation:
            "申請人須將已填妥的表格（甲、乙兩個部分皆須填妥）作為附檔上載給教育局。",
        pdfExplanation2:
            "若教育局發現報名表格尚未完成，會將表格退還給申請人。若出現這個情況，申請人須卸載有關附檔（請按「編輯」鍵），並重新上載已完成的表格，以讓教育局考慮其報名申請。",
    },
    note: {
        note1: {
            title: `1.	你在本表格提供的個人資料，會供教育局用於以下一項或多項用途：`,
            subtitle: "收集個人資料的目的",
            content1:
                "處理、核實及查證就教育局教師網上基礎課程—資優教育的報名程序；",
            content2:
                "就上文(a)項所述報名程序的處理、核實及查證，將個人資料與政府相關政策局／部門資料庫進行核對；",
            content3:
                "將個人資料與教育局資料庫進行核對，以核實／更新教育局的記錄；",
            content4:
                "培訓及發展，包括發出計劃／活動邀請、處理發還課程費用申請、 評審提名、獎項和獎學金，以及監察達標進度；",
            content5:
                "處理及審核撥款／補助／津貼申請、發放撥款／補助／津貼，以及審計； ",
            content6: "編製統計資料、研究及政府刊物；以及",
            content7:
                "執行規則及規例[包括《教育條例》(香港法例第279章)及其附屬法例(例如《教育規例》、《補助學校公積金規則》、《津貼學校公積金規則》)和《資助則例》)]。",
        },
        note2: {
            title: `2.	你必須按本表格的要求及於本局處理本表格的過程中提供個人資料。假如你沒有提供該等個人資料，本局可能無法辦理或繼續處理報名程序。`,
        },
        note3: {
            title: `3.	你提供的個人資料會供教育局人員取閱。除此之外，本局亦可能會向下列各方或在下述情況轉移或披露該等個人資料：`,
            subtitle: "可獲轉移資料者",
            content1: "政府其他政策局及部門，以用於上文第1段所述的用途；",
            content2: "與本表格相關的學校，以用於上文第1段所述的用途；",
            content3:
                "受聘於教育局以提供服務或意見的人員、代理人、服務供應商或機構，以用於上文第1段所述的用途；",
            content4: "你曾就披露個人資料給予訂明同意；以及",
            content5: "根據適用於香港的法例或法庭命令授權或規定披露個人資料。",
        },
        note4: {
            title: `4.	你有權要求查閱及更正教育局所持有關於你的個人資料。如需查閱或更正個人資料，請以書面向行政主任(資優教育)提出(地址：九龍九龍塘沙福道19號教育局九龍塘教育服務中心東座3樓E328室或電郵：<a href="mailto:exoge@edb.gov.hk">exoge@edb.gov.hk</a>)。`,
            subtitle: "查閱個人資料",
        },
    },
    errorMsg: {
        alphabetsOnly: "字符類型只允許 (英文)",
    },
};
export default Form087TC;
